import PageShell from "@/components/PageShell";
import { Historia } from "@/components/landing/Historia";

export default function HistoriaPage() {
  return (
    <PageShell crumbs={[{ label: "Historia" }]}>
      <Historia />
    </PageShell>
  );
}
